//TODO: change merchandising constants number type to currency, decimal, integer
export const mapItemTypeToChannelInfoType = (itemType) => {
  switch(itemType) {
    case 'select':
      return 'Text';
    case 'boolean':
      return 'Bool';
    case 'currency':
    case 'decimal':
      return 'Decimal';
    case 'integer':
      return 'Number';
    default:
      return '';
  }
};

// consolidate app-ui & app-api values together Here for one modal to use in the UI
export const consolidateChannelDetails = ({ 
  defaultChannels,
  channelsConfig=[],
  defaultChannelInfo,
  productChannelInfo=[],
  itemChannelInfo=[],
}) => {
  return defaultChannels.map(defaultChannel => {
    const { publicName, channelId, enabled, isPriceAdjustable } = defaultChannel;
    const matchedChannel = channelsConfig.find(channel => channel.id === channelId);
    const matchedItemChannelInfo = itemChannelInfo.find(ici => ici.channelId === channelId);

    let _enabled=enabled, _discount=null;

    if (matchedItemChannelInfo !== undefined) {
      const { enabled, priceAdjustment } = matchedItemChannelInfo;
      _enabled = enabled;
      _discount = priceAdjustment;
    }
    else if (matchedChannel !== undefined) {
      const { discount } = matchedChannel;
      _discount = discount;
    }

    const fieldValues = consolidateChannelFieldDetails({
      defaultChannelInfo: defaultChannelInfo.filter(dci => dci.channelId === channelId),
      matchedItemChannelInfo,
      matchedProductChannelInfo: productChannelInfo.find(ici => ici.channelId === channelId),
    });

    return {
      ...defaultChannel,
      channelId,
      defaultEnabled: matchedChannel?.enabled ?? defaultChannel.enabled,
      defaultPriceAdjustment: matchedChannel?.discount ?? 0,
      enabled: _enabled,
      fieldValues,
      isPriceAdjustable,
      name: publicName,
      priceAdjustment: matchedItemChannelInfo?.priceAdjustment ?? _discount,
    };
  });
};

// collection of channel fields for 'this' channel ID
// values & required overrided by itemInfo or productInfo If available
// priority = itemInfo > productInfo > defaultInfo
const consolidateChannelFieldDetails = ({
  defaultChannelInfo,
  matchedItemChannelInfo,
  matchedProductChannelInfo,
}) => {
  return defaultChannelInfo.map(defaultChannelItem => {
    const { name: defaultFieldName, publicName, required, type: defaultType, options=[], value=null } = defaultChannelItem;
    let _value=value, _required=required;

    const matchedProductFieldInfo = matchedProductChannelInfo?.fieldValues.find(fv => fv?.field?.key === defaultFieldName);
    const matchedItemFieldInfo = matchedItemChannelInfo?.fieldValues.find(fv => fv?.field?.key === defaultFieldName);

    if (matchedItemFieldInfo) {
      const { value, field: { required } } = matchedItemFieldInfo;
      _value = value;
      _required = required;
    }
    else if (matchedProductFieldInfo) {
      const { value, field: { required } } = matchedProductFieldInfo;
      _value = value;
      _required = required;
    }

    return {
      field: {
        dataType: defaultType,
        key: defaultFieldName,
        publicName,
        required: _required,
      },
      options,
      value: _value,
    }
  });
};

export const mapFieldValuesForSubmission = (fieldValues=[]) => {
  if (fieldValues?.length === 0) {
    return [];
  }

  return fieldValues.filter(fv => fv.value !== null && fv.value !== undefined)
                    .map(fv => {
    const { value, field: { dataType, key, required }} = fv;

    return {
      value,
      field: {
        key,
        dataType: mapItemTypeToChannelInfoType(dataType),
        required,
      },
    };
  });
};

export const mapChannelForSubmission = (itemId, channel) => {
  const { channelId, enabled, priceAdjustment, fieldValues } = channel;

  //TODO: see if we may exclude fieldValues when disabling a channel so does not have to be managed by front-end
  const _fieldValues = enabled 
                        ? mapFieldValuesForSubmission(fieldValues)
                        : [];

  return {
    id: itemId,
    channelId,
    enabled,
    priceAdjustment: priceAdjustment ?? 0,
    fieldValues: _fieldValues,
  };
};

export const areChannelFieldsValid = (channelInfo) => {
  return channelInfo.filter(channel => channel.enabled)
                    .reduce((acc, curr) => {
    // does this channel have a missing, required fieldValue?
    const areRequiredFieldValuesMissing = curr.fieldValues.reduce((fvAcc, fvCurr) => {
      return (fvCurr.field.required && (fvCurr.value === null || fvCurr.value === undefined || fvCurr.value === '')) 
              ? true 
              : fvAcc;
    }, false);

    // channelItems invalid if required field value missing, otherwise pass accumulator
    return areRequiredFieldValuesMissing ? false : acc;
  }, true);
};

export const doEnabledChannelsHaveFields = (channelInfo=[]) => {
  if (channelInfo.length === 0) {
    return false;
  }

  return channelInfo.filter(channel => channel?.enabled ?? false)
                    .find(channel => channel?.fieldValues?.length ?? 0 > 0) !== undefined;
};
